import { Box, Button } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SubmitBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
  margin: '60px 0',

  '& .MuiBox-root': {
    display: 'flex',
    alignItems: 'center',
  },
}));

export const DialogButton = styled(Button)(({ theme }) => ({
  minWidth: 100,
  border: `1px solid ${theme.palette.secondary.main}`,
  color: theme.palette.secondary.main,
  backgroundColor: 'transparent',
  marginRight: 20,
  [theme.breakpoints.down('lg')]: {
    minWidth: '180px',
    maxWidth: '200px',
  },
  [theme.breakpoints.down('xl')]: {
    width: 200,
    padding: 16,
  },
}));

export const DownloadButton = styled(Button)(({ theme }) => ({
  display: 'flex',
  gap: '8px',
  borderRadius: '10px',
  width: ' 250px',
  border: `2px solid ${theme.palette.secondary.main}`,
  color: theme.palette.secondary.main,
  backgroundColor: theme.palette.common.white,
  fontWeight: 600,
  '&:disabled': {
    color: theme.palette.secondary.main,
  },
}));
